import { Grid, Typography } from "@material-ui/core";
import React from "react";

export default function PayJpCardView({
  cardNumberError,
  availableCard,
  cardExpiryError,
  cardCvcError,
  cvvDigits,
  setSaveCard,
  chargeData,
  setUseSavedCard,
  setButtonClickable,
  cardNameError,
  validateCardName,
  validateCardNameOnChange,
  email,
}) {
  return (
    <section className="payjp-wrapper" id="v2-mdc">
      <div className="container">
        <div className="row">
          <label className="field text-field" htmlFor="v2-mdc-card-number">
            {chargeData.creditcard?.cardId && (
              <div className="switch-back">
                <button
                  onClick={() => {
                    setUseSavedCard(true);
                    setButtonClickable(true);
                  }}
                >
                  保存済みのカードを使用する
                </button>
              </div>
            )}
            <Grid container alignItems="center">
              <Grid item md={3}>
                <span className="floating-label">
                  クレジットカード番号 <span className="required">必須</span>
                </span>
              </Grid>
              <Grid item md={6}>
                <div
                  id="v2-mdc-card-number"
                  className="text-field__input"
                ></div>
                <span className="text-field__ripple"></span>
                <span className="line-ripple"></span>
                {cardNumberError && (
                  <Typography className="error-message">
                    カード番号は半角数字14～16桁を入力してください。
                  </Typography>
                )}
                <div className="card-images">
                  {availableCard &&
                    availableCard.cardImages.map((image, id) => (
                      <img src={image} alt="" key={id} />
                    ))}
                </div>
              </Grid>
            </Grid>
          </label>
        </div>
        <div className="row">
          <label
            className="field text-field payjp-expiry"
            htmlFor="v2-mdc-card-expiry"
          >
            <Grid container alignItems="center">
              <Grid item md={3}>
                <span className="floating-label">
                  有効期限 <span className="required">必須</span>
                </span>
              </Grid>
              <Grid item md={6}>
                <div
                  id="v2-mdc-card-expiry"
                  className="text-field__input"
                ></div>
                {cardExpiryError && (
                  <Typography className="error-message">
                    有効期限はカードに記載されている通りに入力してください。
                  </Typography>
                )}
                <span className="text-field__ripple"></span>
                <span className="line-ripple"></span>
              </Grid>
            </Grid>
          </label>
        </div>
        <div className="row">
          <label
            className="field text-field payjp-cvv"
            htmlFor="v2-mdc-card-cvc"
          >
            <Grid container alignItems="center">
              <Grid item md={3}>
                <span className="floating-label">
                  セキュリティコード <span className="required">必須</span>
                </span>
              </Grid>
              <Grid item md={2}>
                <div id="v2-mdc-card-cvc" className="text-field__input"></div>
                {cardCvcError && (
                  <Typography className="error-message">
                    {cvvDigits == 3
                      ? "カード裏面に記載されている3桁の数字です"
                      : " カード表面に記載されている4桁の数字です"}
                  </Typography>
                )}
                <span className="text-field__ripple"></span>
                <span className="line-ripple"></span>
              </Grid>
              <Grid
                item
                md={6}
                style={{ marginLeft: "10px" }}
                className="cvv-text-info"
              >
                <Typography>
                  {cvvDigits == 3
                    ? "※カード裏面に記載されている3桁の数字です"
                    : " カード表面に記載されている4桁の数字です"}
                </Typography>
              </Grid>
            </Grid>
          </label>
        </div>
        <div className="row">
          <label className="field mdc-text-field mdc-text-field--filled">
            <Grid container alignItems="center">
              <Grid item md={3}>
                <span className="mdc-text-field__ripple"></span>
                <span className="floating-label">
                  カード名義 <span className="required">必須</span>
                </span>
              </Grid>
              <Grid item md={6}>
                <input
                  id="v2-mdc-name"
                  className="mdc-text-field__input payjp-card-name"
                  type="text"
                  placeholder="名前"
                  maxLength={45}
                  onChange={(e) => validateCardNameOnChange(e.target.value)}
                  onBlur={(e) => validateCardName(e.target.value)}
                />
                <span className="mdc-line-ripple"></span>
                {cardNameError && (
                  <Typography className="error-message">
                    「半角ローマ字」によるご入力および、姓と名の間に「半角スペース」を45文字以内でご入力ください。
                  </Typography>
                )}
              </Grid>
            </Grid>
          </label>
        </div>
        <div className="row last-row">
          <label className="field mdc-text-field mdc-text-field--filled">
            <Grid container alignItems="center">
              <Grid item md={3}>
                <span className="mdc-text-field__ripple"></span>
                <span className="floating-label">メールアドレス</span>
              </Grid>
              <Grid item md={6}>
                <input
                  id="v2-mdc-name"
                  className="mdc-text-field__input payjp-email"
                  type="email"
                  placeholder="メールアドレス"
                  value={email}
                  disabled
                />
                <span className="mdc-line-ripple"></span>
              </Grid>
            </Grid>
          </label>
        </div>
        <div className="save-data">
          <input
            type="checkbox"
            name=""
            id="save_card"
            onChange={(e) => setSaveCard(e.target.checked)}
          />
          <label htmlFor="save_card">クレジットカード情報を保存する</label>
        </div>
      </div>
    </section>
  );
}
